import React, { Component } from 'react';
import UserProfileAvatar from './UserProfileAvatar.js';
import update from 'immutability-helper';
import './UserProfile.css';

export default class extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        name: 'Guest',
        status: 'in-progress',
        estimate: ''
      }
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user !== this.state.user)
      this.setUser(nextProps.user);
  }

  handleChange(event) {
    this.setUser({ name: event.target.value });
  }

  handleBlur(event) {
    this.changeName(event.target.value.trim());
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.nameInput.blur();
      this.changeName(event.target.value.trim());
    }
  }

  setUser(user) {
    let newUser = update(this.state.user, {$merge: user});
    this.setState({ user: newUser })
  }

  changeName(name) {
    if (name) {
      this.props.updateUser(this.state.user);
    } else {
      this.setUser(this.props.user)
    }
  }

  render() {
    return (
      <div className="user-profile">
        <UserProfileAvatar
          name={this.state.user.name}
          status={this.state.user.status}
          estimate={this.state.user.estimate}
          roomShowEstimate={this.props.roomShowEstimate}
          roomCurrentStepType={this.props.roomCurrentStepType} />
        <input className="display-name" type="text"
          maxLength="15"
          onChange={this.handleChange}
          onKeyPress={this.handleKeyPress}
          onBlur={this.handleBlur}
          value={this.state.user.name}
          disabled={!this.props.canEdit}
          ref={(input) => { this.nameInput = input; }} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Room/UserProfile.js